import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Urbaniaforpune() {

const cardData = {
keyword: "Urbania for Pune to Mahabaleshwar Hire",
headingDescription: "Urbania for Pune to Mahabaleshwar Hire is a convenient group travel option for families, friends, corporate teams, and tour groups planning a journey from Pune to the scenic hill station of Mahabaleshwar. Ruturaj Enterprises provides spacious Urbania options including 13-seater, 14-seater, 17-seater, and 20-seater vehicles for one-way travel, round trips, family holidays, sightseeing tours, and group outings. With professional driver assistance and flexible travel arrangements, passengers can comfortably plan their Pune to Mahabaleshwar journey around their preferred pickup location, itinerary, sightseeing schedule, and return date.",
topPlaces: [
{
title: "Mahabaleshwar Market",
description: "Mahabaleshwar Market is a popular central shopping area where visitors can explore local products, snacks, strawberries, handicrafts, and other items. An Urbania group can conveniently include the market in a planned sightseeing itinerary after travelling from Pune."
},
{
title: "Venna Lake",
description: "Venna Lake is one of Mahabaleshwar's well-known tourist attractions and is popular for boating, lakeside walks, and leisure activities. Groups travelling from Pune can include Venna Lake as part of their Urbania sightseeing schedule."
},
{
title: "Mapro Garden",
description: "Mapro Garden near Mahabaleshwar is a popular stop for families and tourist groups interested in strawberry products, chocolates, snacks, and garden surroundings. Urbania transportation provides a practical way for larger groups to include the location in their trip itinerary."
},
{
title: "Arthur's Seat",
description: "Arthur's Seat is a well-known viewpoint in the Mahabaleshwar region offering impressive valley and hill views. An Urbania hire from Pune can help groups travel together while covering this viewpoint along with other attractions during a planned Mahabaleshwar sightseeing tour."
},
{
title: "Elephant's Head Point",
description: "Elephant's Head Point is a popular scenic viewpoint known for its mountain and valley landscapes. Families, friends, and tour groups travelling from Pune can include this destination in a full-day or multi-day Mahabaleshwar Urbania itinerary."
},
{
title: "Pratapgad Fort",
description: "Pratapgad Fort is a historic destination located near Mahabaleshwar and is frequently included in regional sightseeing and heritage itineraries. A spacious Urbania is useful for groups planning to combine Mahabaleshwar attractions with a visit to the fort."
},
{
title: "Panch Ganga Temple",
description: "Panch Ganga Temple is an important religious and historical attraction in Mahabaleshwar. Urbania group transportation can make it easier for families and pilgrimage groups to include the temple along with other local sightseeing points during their Pune to Mahabaleshwar journey."
},
{
title: "Kate's Point",
description: "Kate's Point is a scenic viewpoint in the Mahabaleshwar area offering expansive views of the surrounding landscape. Groups travelling together can add this attraction to their sightseeing plan while using an Urbania for convenient transportation between multiple destinations."
},
{
title: "Lingmala Waterfall",
description: "Lingmala Waterfall is a popular seasonal attraction near Mahabaleshwar and is often included in nature-focused travel plans. An Urbania provides shared transportation for families and groups who want to explore the waterfall and other nearby attractions during their trip."
},
{
title: "Table Land Panchgani",
description: "Table Land in nearby Panchgani is a major plateau and sightseeing destination that can be combined with a Mahabaleshwar tour. Groups hiring an Urbania from Pune can plan a combined Mahabaleshwar and Panchgani itinerary according to their available travel time."
}
],
services: [
{
name: "Pune to Mahabaleshwar Urbania on Rent",
description: "Pune to Mahabaleshwar Urbania on Rent is suitable for families, friends, corporate groups, and tourists travelling together to the hill station. The vehicle can be arranged for one-way journeys, return trips, sightseeing tours, and multi-day travel plans."
},
{
name: "Pune to Mahabaleshwar Urbania Hire",
description: "Pune to Mahabaleshwar Urbania Hire provides a spacious group transportation option for customers planning a comfortable journey from Pune. It can be used for family holidays, weekend trips, corporate outings, wedding travel, sightseeing, and organized group tours."
},
{
name: "Pune to Mahabaleshwar Urbania Booking",
description: "Pune to Mahabaleshwar Urbania Booking allows customers to organize their group transportation according to the travel date, passenger count, pickup location, itinerary, and return requirements. Advance planning is useful during holidays, weekends, and planned group tours."
},
{
name: "Urbania Traveller Pune to Mahabaleshwar",
description: "Urbania Traveller Pune to Mahabaleshwar is suitable for groups looking for shared transportation throughout the journey. It can be arranged for family vacations, friend groups, corporate outings, sightseeing programs, and multi-day Mahabaleshwar trips."
},
{
name: "Urbania Van Pune to Mahabaleshwar",
description: "Urbania Van Pune to Mahabaleshwar provides a spacious travel option for groups travelling from Pune to the hill station. The vehicle can accommodate passengers together and is suitable for planned sightseeing, family trips, group holidays, and return journeys."
},
{
name: "13 Seater Urbania Pune to Mahabaleshwar",
description: "13 Seater Urbania Pune to Mahabaleshwar is suitable for smaller and medium-sized groups planning a shared hill-station trip. It can be arranged for family holidays, friend groups, sightseeing tours, corporate outings, and one-way or round-trip travel."
},
{
name: "14 Seater Urbania Pune to Mahabaleshwar",
description: "14 Seater Urbania Pune to Mahabaleshwar provides a practical option for groups requiring slightly higher passenger capacity. It is suitable for family vacations, tourist groups, corporate travel, weekend outings, and planned sightseeing around Mahabaleshwar and nearby destinations."
},
{
name: "17 Seater Urbania Pune to Mahabaleshwar",
description: "17 Seater Urbania Pune to Mahabaleshwar is useful for larger families, corporate teams, friends, and organized tour groups. The vehicle can be arranged for round trips, sightseeing schedules, multi-day stays, and journeys covering Mahabaleshwar and surrounding attractions."
},
{
name: "20 Seater Urbania Pune to Mahabaleshwar",
description: "20 Seater Urbania Pune to Mahabaleshwar is suitable for larger groups travelling together for holidays, corporate outings, family functions, and organized tours. A single spacious vehicle helps simplify group coordination during the journey and sightseeing schedule."
},
{
name: "Luxury Urbania Pune to Mahabaleshwar",
description: "Luxury Urbania Pune to Mahabaleshwar provides a premium group travel option for customers looking for a more comfortable journey. It can be arranged for family vacations, corporate trips, special occasions, sightseeing tours, and longer stays in the Mahabaleshwar region."
},
{
name: "Urbania for Mahabaleshwar Trip from Pune",
description: "Urbania for Mahabaleshwar Trip from Pune is suitable for customers planning a complete group holiday with multiple sightseeing stops. The vehicle can support a customized itinerary covering viewpoints, temples, markets, nature attractions, and nearby destinations."
},
{
name: "Urbania for Mahabaleshwar Family Trip",
description: "Urbania for Mahabaleshwar Family Trip provides convenient shared transportation for families travelling together from Pune. It is suitable for parents, children, relatives, and larger family groups planning sightseeing, leisure activities, and a return journey."
},
{
name: "Urbania for Mahabaleshwar Group Travel",
description: "Urbania for Mahabaleshwar Group Travel is designed for friends, families, corporate teams, and organized tourist groups. A dedicated vehicle allows the group to travel together while following a common sightseeing and accommodation schedule."
},
{
name: "Urbania Rental Pune to Mahabaleshwar",
description: "Urbania Rental Pune to Mahabaleshwar provides a group transportation solution for customers travelling from Pune to Mahabaleshwar for holidays, sightseeing, family trips, corporate outings, and special events. Rental arrangements can be planned around the complete itinerary."
},
{
name: "Urbania Outstation Hire Pune to Mahabaleshwar",
description: "Urbania Outstation Hire Pune to Mahabaleshwar is suitable for groups requiring dedicated transportation for an intercity journey. It can be arranged for one-way travel, return trips, sightseeing programs, and multi-day outstation itineraries."
},
{
name: "Urbania Round Trip Pune to Mahabaleshwar",
description: "Urbania Round Trip Pune to Mahabaleshwar is convenient for groups planning to travel from Pune, spend time sightseeing or staying in Mahabaleshwar, and return to Pune. The journey can be organized according to the group's preferred dates and itinerary."
},
{
name: "Urbania Traveller Rental for Mahabaleshwar",
description: "Urbania Traveller Rental for Mahabaleshwar is suitable for families, tourists, friends, and corporate groups planning a dedicated vehicle for their hill-station journey. It can be used for local sightseeing, nearby attractions, and return transportation."
},
{
name: "Urbania for Mahabaleshwar Tour Pune",
description: "Urbania for Mahabaleshwar Tour Pune is a suitable group transportation option for organized tours starting from Pune. Customers can plan a sightseeing itinerary covering Mahabaleshwar attractions and nearby Panchgani or other destinations based on their available time."
},
{
name: "Urbania Hire Near Me Pune to Mahabaleshwar",
description: "Urbania Hire Near Me Pune to Mahabaleshwar is useful for customers searching for a nearby group vehicle for their planned hill-station journey. Pickup arrangements can be discussed according to the customer's Pune location, group size, travel date, and destination."
},
{
name: "Affordable Urbania Pune to Mahabaleshwar",
description: "Affordable Urbania Pune to Mahabaleshwar is suitable for groups looking for shared transportation while managing their overall trip budget. Rental requirements can vary according to vehicle capacity, travel duration, route, kilometres, sightseeing stops, and whether the journey is one-way or round trip."
}
],
tableData: [
["Pune to Mahabaleshwar Urbania on Rent"],
["Pune to Mahabaleshwar Urbania Hire"],
["Pune to Mahabaleshwar Urbania Booking"],
["Urbania Traveller Pune to Mahabaleshwar"],
["Urbania Van Pune to Mahabaleshwar"],
["13 Seater Urbania Pune to Mahabaleshwar"],
["14 Seater Urbania Pune to Mahabaleshwar"],
["17 Seater Urbania Pune to Mahabaleshwar"],
["20 Seater Urbania Pune to Mahabaleshwar"],
["Luxury Urbania Pune to Mahabaleshwar"],
["Urbania for Mahabaleshwar Trip from Pune"],
["Urbania for Mahabaleshwar Family Trip"],
["Urbania for Mahabaleshwar Group Travel"],
["Urbania Rental Pune to Mahabaleshwar"],
["Urbania Outstation Hire Pune to Mahabaleshwar"],
["Urbania Round Trip Pune to Mahabaleshwar"],
["Urbania Traveller Rental for Mahabaleshwar"],
["Urbania for Mahabaleshwar Tour Pune"],
["Urbania Hire Near Me Pune to Mahabaleshwar"],
["Affordable Urbania Pune to Mahabaleshwar"]
],
whychoose: [
{
WhyChooseheading: "Spacious Travel for Mahabaleshwar Groups",
WhyChoosedescription: "Ruturaj Enterprises provides Urbania options that allow families, friends, corporate teams, and organized tour groups to travel together from Pune to Mahabaleshwar. Shared transportation makes group coordination easier throughout the journey and sightseeing schedule."
},
{
WhyChooseheading: "Multiple Urbania Seating Options",
WhyChoosedescription: "Group sizes can vary considerably for hill-station trips, so different vehicle capacities can be useful. Customers can consider 13-seater, 14-seater, 17-seater, or 20-seater Urbania options according to their passenger count and travel requirements."
},
{
WhyChooseheading: "Suitable for Round Trips",
WhyChoosedescription: "Many Mahabaleshwar visitors plan a return journey to Pune after completing their sightseeing or stay. A round-trip Urbania arrangement can keep the same group transportation available according to the planned departure and return schedule."
},
{
WhyChooseheading: "Convenient for Sightseeing Itineraries",
WhyChoosedescription: "Mahabaleshwar has numerous viewpoints, temples, markets, nature attractions, and nearby destinations that groups may want to cover in one itinerary. A dedicated Urbania makes it easier to coordinate travel between multiple sightseeing locations."
},
{
WhyChooseheading: "Useful for Family Holidays",
WhyChoosedescription: "Families travelling with children, parents, and relatives can benefit from having a shared vehicle for the complete Pune to Mahabaleshwar journey. Urbania transportation can support family sightseeing, leisure trips, temple visits, and planned return travel."
},
{
WhyChooseheading: "Professional Driver Assistance",
WhyChoosedescription: "Having a professional driver is useful for groups travelling on unfamiliar hill routes and managing a sightseeing itinerary. Passengers can focus on their holiday while transportation is handled according to the agreed pickup points, route, and destinations."
},
{
WhyChooseheading: "Suitable for Nearby Attractions",
WhyChoosedescription: "A Mahabaleshwar trip can include nearby attractions and destinations such as Panchgani and Pratapgad depending on the available time. An Urbania allows larger groups to plan combined sightseeing without arranging separate vehicles for different portions of the trip."
},
{
WhyChooseheading: "Flexible One-Way and Outstation Planning",
WhyChoosedescription: "Different travellers have different schedules, so Urbania transportation can be planned around one-way journeys, round trips, multi-day stays, and customized outstation itineraries. The arrangement can be discussed according to the group's route, dates, passenger count, and travel plans."
}
]
};



















const faqData = [
{
question: "How can I hire an Urbania for Pune to Mahabaleshwar travel?",
answer: "Travellers can enquire about an Urbania by sharing their Pune pickup location, Mahabaleshwar destination, journey date, passenger count, reporting time, and expected travel schedule. Ruturaj Enterprises can arrange the group transportation according to the planned itinerary and trip duration."
},
{
question: "Why choose an Urbania for a Pune to Mahabaleshwar group trip?",
answer: "An Urbania is suitable when a group wants to travel together from Pune to Mahabaleshwar in one dedicated vehicle. It can be considered for family holidays, friends' trips, corporate outings, college groups, and sightseeing programs where coordinated transportation is important."
},
{
question: "Can I hire an Urbania from Pune to Mahabaleshwar for a family trip?",
answer: "Families can arrange an Urbania for a Mahabaleshwar holiday when several members are travelling together. The vehicle can be planned for pickup from homes, societies, hotels, or other convenient locations in Pune and travel to Mahabaleshwar according to the family's sightseeing and stay schedule."
},
{
question: "Is Urbania available for Pune to Mahabaleshwar sightseeing?",
answer: "An Urbania can be used for a planned Mahabaleshwar sightseeing itinerary covering popular attractions and nearby locations. Groups can discuss places such as Venna Lake, Mapro Garden, Arthur's Seat, Elephant's Head Point, Panch Ganga Temple, and other destinations while finalizing the travel schedule."
},
{
question: "Can I hire an Urbania for a Pune to Mahabaleshwar weekend trip?",
answer: "Weekend travellers can enquire about an Urbania for short Mahabaleshwar trips from Pune. The rental arrangement can be planned around the departure time, hotel check-in, sightseeing schedule, overnight stay, and return journey so that the group can coordinate the complete trip in advance."
},
{
question: "Can an Urbania be hired for a Pune to Mahabaleshwar corporate outing?",
answer: "Companies can arrange an Urbania for employee outings, team trips, corporate retreats, and group travel from Pune to Mahabaleshwar. Sharing the employee count, pickup points, destination schedule, meeting locations, and return timing helps in planning transportation around the corporate itinerary."
},
{
question: "Can I use an Urbania for a Pune to Mahabaleshwar wedding or family function?",
answer: "Families can consider an Urbania when relatives or guests need to travel from Pune to Mahabaleshwar for weddings, celebrations, or other functions. Pickup points, accommodation details, venue timings, passenger count, and return requirements can be discussed while arranging the vehicle."
},
{
question: "Does Urbania rental from Pune to Mahabaleshwar include a return journey?",
answer: "A round-trip Urbania arrangement can be discussed when the group plans to return from Mahabaleshwar to Pune after the trip. Travellers can provide their departure and return dates, sightseeing duration, hotel details, and preferred reporting times so the transportation plan matches the complete itinerary."
},
{
question: "Can I hire an Urbania from Pune for a multi-day Mahabaleshwar trip?",
answer: "For longer Mahabaleshwar holidays, groups can enquire about multi-day Urbania rental arrangements. The schedule can include Pune pickup, hotel transfers, local sightseeing, nearby attractions, multiple-day travel, and the return journey based on the group's planned route and duration."
},
{
question: "What information is required to book an Urbania for Pune to Mahabaleshwar?",
answer: "To plan the vehicle, travellers can share the Pune pickup location, Mahabaleshwar hotel or destination, journey date, passenger count, number of travel days, sightseeing requirements, departure time, and return schedule. Ruturaj Enterprises can use these details to understand the group's transportation requirements."
}
];

const testimonials = [
{
id: 1,
name: "Mr. Amit Kulkarni",
feedback:
"We planned a weekend Mahabaleshwar trip with a group of friends from Pune and chose an Urbania for the journey. The single vehicle made it easier for everyone to stay together during the Pune pickup, sightseeing, hotel transfer, and return trip. Ruturaj Enterprises handled the group transportation according to our planned schedule.",
rating: 5
},
{
id: 2,
name: "Miss. Neha Joshi",
feedback:
"Our extended family travelled from Pune to Mahabaleshwar for a short holiday, with several members coming from different parts of the city. We arranged an Urbania through Ruturaj Enterprises and coordinated the pickup before departure. Having everyone travel together made the sightseeing and return arrangements much simpler.",
rating: 5
}
];






































    const Images = [
        { place: "/images/keyword/1.jpg", text: "Tempo Traveller On Rent in Pune", link: "Tempo-Traveller-On-Rent-in-Pune" },
        { place: "/images/keyword/2.jpg", text: "Pune to Shirdi Tempo Traveller on Rent", link: "Pune-to-Shirdi-Tempo-Traveller-on-Rent" },
        { place: "/images/keyword/3.jpg", text: "Pune to Mahabaleshwar Tempo Traveller on Rent", link: "Pune-to-Mahabaleshwar-Tempo-Traveller-on-Rent" },
        { place: "/images/keyword/4.jpg", text: "Pune to Goa Tempo Traveller", link: "Pune-to-Goa-Tempo-Traveller" },
        { place: "/images/keyword/5.jpg", text: "Pune to Mumbai Tempo Traveller on Rent", link: "Pune-to-Mumbai-Tempo-Traveller-on-Rent" },
        { place: "/images/keyword/6.jpg", text: "Pune to Konkan Tempo Traveller", link: "Pune-to-Konkan-Tempo-Traveller" },
        { place: "/images/keyword/7.jpg", text: "Pune to Nashik Tempo Traveller On Rent", link: "Pune-to-Nashik-Tempo-Traveller-On-Rent" },
        { place: "/images/keyword/8.jpg", text: "Pune Darshan Tempo Traveller On Rent", link: "Pune-Darshan-Tempo-Traveller-On-Rent" },
        { place: "/images/keyword/9.jpg", text: "Mini Bus On Rent in Pune", link: "Mini-Bus-On-Rent-in-Pune" },
        { place: "/images/keyword/10.jpg", text: "13 Seater Tempo Traveller on Rent", link: "13-Seater-Tempo-Traveller-on-Rent" },
        { place: "/images/keyword/11.jpg", text: "17 Seater Tempo Traveller on Rent in Pune", link: "17-Seater-Tempo-Traveller-on-Rent-in-Pune" },
        { place: "/images/keyword/12.jpg", text: "20 Seater Bus on Rent in Pune", link: "20-Seater-Bus-on-Rent-in-Pune" },
        { place: "/images/keyword/13.jpg", text: "26 Seater Tempo Traveller on Rent in Pune", link: "26-Seater-Tempo-Traveller-on-Rent-in-Pune" },
        { place: "/images/keyword/14.jpg", text: "32 Seater Bus Rent in Pune", link: "32-Seater-Bus-Rent-in-Pune" },
        { place: "/images/keyword/15.jpg", text: "35 Seater Bus on Rent in Pune", link: "35-Seater-Bus-on-Rent-in-Pune" },
        { place: "/images/keyword/16.jpg", text: "45 Seater Bus on Rent in Pune", link: "45-Seater-Bus-on-Rent-in-Pune" },
        { place: "/images/keyword/17.jpg", text: "50 Seater Bus On Rent in Pune", link: "50-Seater-Bus-On-Rent-in-Pune" },
        { place: "/images/keyword/18.jpg", text: "Bus Rentals For School Trips in Pune", link: "Bus-Rentals-For-School-Trips-in-Pune" },
        { place: "/images/keyword/19.jpg", text: "Bus booking for wedding in Pune", link: "Bus-booking-for-wedding-in-Pune" },
        { place: "/images/keyword/20.jpg", text: "Bus Booking for Marriage", link: "Bus-Booking-for-Marriage" },
        { place: "/images/keyword/21.jpg", text: "Bus Service for Corporate Pune", link: "Bus-Service-for-Corporate-Pune" },
        { place: "/images/keyword/22.jpg", text: "Bus on Rent For Event in Pune", link: "Bus-on-Rent-For-Event-in-Pune" },
        { place: "/images/keyword/23.jpg", text: "Bus Hire for Outstation", link: "Bus-Hire-for-Outstation" },
        { place: "/images/keyword/24.jpg", text: "AC Bus On Rent in Pune", link: "AC-Bus-On-Rent-in-Pune" },
        { place: "/images/keyword/25.jpg", text: "Pune Bus Hire Rental Service", link: "Pune-Bus-Hire-Rental-Service" },
    ];







const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Urbania for Pune to Mahabaleshwar Hire",
  "image": "https://ruturajenterprises.com/assets/images/urbania-for-pune-to-mahabaleshwar-hire.webp",
  "description": "Urbania for Pune to Mahabaleshwar Hire from Ruturaj Enterprises is a comfortable group travel option for families, friends, corporate teams and larger groups planning a journey from Pune to the scenic hill station of Mahabaleshwar. Pune to Mahabaleshwar Urbania on Rent, Pune to Mahabaleshwar Urbania Hire and Pune to Mahabaleshwar Urbania Booking are suitable for planned one-way and round-trip journeys with convenient pickup arrangements in Pune. Urbania Traveller Pune to Mahabaleshwar and Urbania Van Pune to Mahabaleshwar provide spacious transportation for groups travelling together, while 13 Seater Urbania Pune to Mahabaleshwar, 14 Seater Urbania Pune to Mahabaleshwar, 17 Seater Urbania Pune to Mahabaleshwar and 20 Seater Urbania Pune to Mahabaleshwar can be selected according to the size of the travelling group. Luxury Urbania Pune to Mahabaleshwar offers a premium and comfortable option for longer hill-station travel. Urbania for Mahabaleshwar Trip from Pune can be arranged for sightseeing, weekend holidays, family vacations and group tours. Urbania for Mahabaleshwar Family Trip and Urbania for Mahabaleshwar Group Travel are suitable for passengers who prefer travelling together rather than using multiple smaller vehicles. Urbania Rental Pune to Mahabaleshwar and Urbania Outstation Hire Pune to Mahabaleshwar can support planned intercity transportation, while Urbania Round Trip Pune to Mahabaleshwar is suitable for travellers returning to Pune after their Mahabaleshwar visit. Urbania Traveller Rental for Mahabaleshwar and Urbania for Mahabaleshwar Tour Pune provide additional options for sightseeing and extended travel plans. Customers searching for Urbania Hire Near Me Pune to Mahabaleshwar can enquire about pickup availability, seating capacity and trip requirements, while Affordable Urbania Pune to Mahabaleshwar provides a practical group transportation option for budget-conscious travellers.",
  "brand": {
    "@type": "Brand",
    "name": "Ruturaj Enterprises"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "8517"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "Starting From ₹12/Km",
    "availability": "https://schema.org/InStock",
    "url": "https://ruturajenterprises.com/urbania-for-pune-to-mahabaleshwar-hire"
  }
};









    return (
        <div>
<Helmet>
  <title>
    Urbania for Pune to Mahabaleshwar Hire | 13, 14, 17 & 20 Seater Luxury Traveller | +91 9763381382
  </title>

  <meta
    name="description"
    content="Urbania for Pune to Mahabaleshwar Hire by Ruturaj Enterprises for family trips, group tours and round trips with 13, 14, 17 and 20 seater Urbania options."
  />

  <meta
    name="keywords"
    content="Urbania for Pune to Mahabaleshwar Hire, Pune to Mahabaleshwar Urbania on Rent, Pune to Mahabaleshwar Urbania Hire, Pune to Mahabaleshwar Urbania Booking, Urbania Traveller Pune to Mahabaleshwar, Urbania Van Pune to Mahabaleshwar, 13 Seater Urbania Pune to Mahabaleshwar, 14 Seater Urbania Pune to Mahabaleshwar, 17 Seater Urbania Pune to Mahabaleshwar, 20 Seater Urbania Pune to Mahabaleshwar, Luxury Urbania Pune to Mahabaleshwar, Urbania for Mahabaleshwar Trip from Pune, Urbania for Mahabaleshwar Family Trip, Urbania for Mahabaleshwar Group Travel, Urbania Rental Pune to Mahabaleshwar, Urbania Outstation Hire Pune to Mahabaleshwar, Urbania Round Trip Pune to Mahabaleshwar, Urbania Traveller Rental for Mahabaleshwar, Urbania for Mahabaleshwar Tour Pune, Urbania Hire Near Me Pune to Mahabaleshwar, Affordable Urbania Pune to Mahabaleshwar, Urbania with Driver Pune to Mahabaleshwar, AC Urbania Pune to Mahabaleshwar, Urbania Sightseeing Mahabaleshwar, Mahabaleshwar Tour from Pune Urbania, Pune Mahabaleshwar Group Cab, Pune to Mahabaleshwar Family Cab, Pune to Mahabaleshwar Luxury Traveller, Pune to Mahabaleshwar Outstation Urbania, Pune to Mahabaleshwar Round Trip Traveller, Urbania Rental with Driver Pune, Mahabaleshwar Sightseeing Urbania, Urbania for Weekend Trip Mahabaleshwar"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>





            <div
                className="ltn__breadcrumb-area ltn__breadcrumb-area-2 ltn__breadcrumb-color-white bg-overlay-theme-black-90 bg-image"
                style={{ backgroundImage: "url('/img/bg/9.jpg')" }}
            >
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="ltn__breadcrumb-inner ltn__breadcrumb-inner-2 justify-content-between">
                                <div className="section-title-area ltn__section-title-2">
                                    <h1 className="section-title white-color">
                                        {cardData.keyword}
                                    </h1>
                                </div>


                            </div>
                        </div>
                    </div>
                </div>
            </div>






















            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/111.png' alt='img' className='img-fluid' />
                            <h3 className="py-1"
                                style={{
                                    color: '#FF681A', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >Ruturaj Enterprises: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="topPlaces">

                                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard borderr" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>

                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>


                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div key={index} className="service-row">

                                        <div>
                                            <h4 className="service-title">{service.name}</h4>
                                            <p className="service-desc">{service.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>


                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable /> */}

                            <div id="why-choose-section" className="why-choose-section">


                                {/* Section Title */}
                                <h2 className="section-title text-white">
                                    Why Choose <span>Ruturaj Enterprises</span>
                                </h2>


                                {/* Cards */}
                                <div className="cards-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div key={index} className="why-card">
                                            <div className="icon-circle">{index + 1}</div>
                                            <h4 className="card-heading">{item.WhyChooseheading}</h4>
                                            <p className="card-desc">{item.WhyChoosedescription}</p>
                                        </div>
                                    ))}
                                </div>
                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Ruturaj Enterprises </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase keyword={cardData.keyword} />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                {/* <FleetHighway /> */}
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-telephone-fill"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+919763381382" className="pc-call">+91 9763381382</a>
                                        </div>

                                        <div className="pc-list">
                                            <a href="tel:+919011051114" className="pc-call">+91 9011051114</a>
                                        </div>

                                        <div className="pc-list">
                                            <a href="tel:+919822697554" className="pc-call">+91 9822697554</a>
                                        </div>

                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/919763381382"
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp"></i> WhatsApp
                                            </a>
                                            <a href="tel:+919763381382" className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-envelope-fill"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@ruturajenterprises.com" className="pc-email">
                                            booking@ruturajenterprises.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-geo-alt-fill"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Ruturaj Enterprises</strong><br />

                                            Nandini Takle Nagar, Pune - Solapur Road Manjri Bk Hadapsar, Pune, Maharashtra 412307
                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Urbaniaforpune;